import styled from 'styled-components';
import ThemeHelper from '@themes/theme-helper';

export const Root = styled.div(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border: 1px solid ${colours.grey[400]};
    border-left: none;
    border-top: none;
    height: 33px;
    background-color: white;
  `;
});

export const StudentItem = styled.div(props => {
  const { palette, colours } = ThemeHelper.getTheme(props);

  return `
    display: flex;
    justify-content: space-between;
    align-items: center
    width: 80%;
    height: 22px;
    padding: 5px;
    font-weight: 400;
    border-right: 2px solid ${colours.grey[400]};
    color: ${palette.primary.dark};
    cursor: pointer;
	line-height: 14px;
  `;
});

export const AssignmentCountText = styled.span(props => {
  const { palette } = ThemeHelper.getTheme(props);

  return `
    color: ${palette.primary.dark};
  `;
});

export const CheckboxWrapper = styled.span(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    display: flex;
    justify-content: center;
    align-items: center;

    width: 40px;
    height: 100%;
    background-color: ${colours.grey[200]};

    > div {
      margin: 0;
    }
`;
});
